import { RouteObject } from 'react-router-dom';
import loadable from '@loadable/component';

const CRMTasksPage = loadable(() => import('@/pages/CRM/TasksPage'));

export enum CRMTaskRoutes {
  CRMTasks = '/crm/tasks',
  CRMTasksWithInstanceIdAndDate = '/crm/tasks/:task_instance_id/:task_date'
}

export const getCrmTasksRoutes = (): RouteObject[] => {
  return [
    {
      path: CRMTaskRoutes.CRMTasks,
      element: <CRMTasksPage />
    },
    {
      path: CRMTaskRoutes.CRMTasksWithInstanceIdAndDate,
      element: <CRMTasksPage />
    }
  ];
};
